var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn btn-link btn-icon",class:{ 'btn-lg': _vm.size === 'lg', 'btn-sm': _vm.size === 'sm' }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }